<template>
  <div>
    <transition name="slide">
      <div :key="'type'">
        <div
          class="do_title"
          style="margin-bottom: 18px; display: flex; padding-left: 10px; padding-right: 10px;"
        >
          <span
            class="bh_back pointer"
            @click="back"
            v-if="canGoBack"
            style="padding-right: 20px"
          >
            <img
              :src="require('@/assets/img/facebook/back_str.svg')"
              alt="back"
            />
          </span>
          <span>{{ text('website_ask_type') }}</span>
        </div>
        <div class="delivery_oplata substrate" style="margin-top: 0">
          <div class="delivery_oplata_list" style="margin-top: 0">
            <label class="dol_block" v-for="item in types">
              <input
                :value="item.id"
                name="type"
                type="radio"
                v-model="type_id"
              />
              <div class="dol_content">
                <div class="dol_inner">
                  <div class="dol_name">
                    <template>{{ item.name }}</template>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      </div>
    </transition>

    <div :key="'outlets'">
      <transition name="slide">
        <div
          class="delivery_oplata substrate"
          style="margin-bottom: 100px"
          v-if="
            type_id !== null &&
            type_id !== 3 &&
            (guardShowChooseOutletsAlways || outlets.length > 1)
          "
        >
          <div
            class="do_title"
            style="display: flex; justify-content: space-between"
          >
            <div>
              {{ text('website_ask_outlet') }}
            </div>
            <div class="sort-geo-button-div">
              <div @click="sortByGeo()">
                <svg
                  width="59"
                  height="48"
                  viewBox="0 0 59 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      d="M6 22C6 16.4087 6 13.6131 6.91345 11.4078C8.13137 8.46746 10.4675 6.13137 13.4078 4.91345C15.6131 4 18.4087 4 24 4H35C40.5913 4 43.3869 4 45.5922 4.91345C48.5325 6.13137 50.8686 8.46746 52.0866 11.4078C53 13.6131 53 16.4087 53 22C53 27.5913 53 30.3869 52.0866 32.5922C50.8686 35.5325 48.5325 37.8686 45.5922 39.0866C43.3869 40 40.5913 40 35 40H24C18.4087 40 15.6131 40 13.4078 39.0866C10.4675 37.8686 8.13137 35.5325 6.91345 32.5922C6 30.3869 6 27.5913 6 22Z"
                      fill="white"
                    />
                  </g>
                  <circle
                    v-if="$store.getters.loading[GUARD_SORT_OUTLETS] === true"
                    class="path circle"
                    cx="30"
                    cy="22"
                    fill="none"
                    r="10"
                    stroke="#0084ff"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  />
                  <path
                    v-else
                    d="M30 10C26.686 10 24 12.686 24 16C24 19.323 27.6066 24.1059 29.2266 26.0879C29.6276 26.5779 30.3705 26.5779 30.7715 26.0879C32.3925 24.1059 36 19.323 36 16C36 12.686 33.314 10 30 10ZM30 13.8574C31.184 13.8574 32.1426 14.816 32.1426 16C32.1426 17.183 31.183 18.1426 30 18.1426C28.817 18.1426 27.8574 17.184 27.8574 16C27.8574 14.816 28.816 13.8574 30 13.8574ZM24.9941 24.5645C24.9172 24.5647 24.8384 24.5744 24.7598 24.5938C21.9048 25.2987 20 26.56 20 28C20 30.209 24.477 32 30 32C35.523 32 40 30.209 40 28C40 26.56 38.0952 25.2997 35.2402 24.5957C34.6112 24.4407 34 24.9262 34 25.5742C34 26.0282 34.3022 26.434 34.7422 26.543C36.5472 26.991 37.6442 27.612 37.9492 27.998C37.4342 28.653 34.694 29.998 30 29.998C25.306 29.998 22.5658 28.653 22.0508 27.998C22.3548 27.611 23.4528 26.991 25.2578 26.543C25.6978 26.435 26 26.0282 26 25.5742C26 25.0063 25.5325 24.5625 24.9941 24.5645Z"
                    fill="#3785F6"
                  />
                  <defs>
                    <filter
                      id="filter0_d"
                      x="0"
                      y="0"
                      width="59"
                      height="48"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      />
                      <feOffset dy="2"/>
                      <feGaussianBlur stdDeviation="3"/>
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div class="delivery_oplata_list">
            <transition-group name="flip-list" tag="label">
              <label
                class="dol_block"
                v-for="outlet in outlets"
                :key="outlet.identifier"
              >
                <input
                  :value="outlet.identifier"
                  name="outlet"
                  type="radio"
                  v-model="identifier"
                />
                <div class="dol_content">
                  <div class="dol_inner">
                    <svg
                      v-if="outlet.favorite"
                      width="15"
                      height="15"
                      style="top: 0; position: absolute; left: 20px"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      preserveAspectRatio="xMidYMid meet"
                      viewBox="0 0 640 640"
                    >
                      <defs>
                        <path
                          d="M320 393.53L0 640L0 0L640 0L640 640L320 393.53Z"
                          id="b1A6lYlsPS"
                        ></path>
                      </defs>
                      <g>
                        <g>
                          <g>
                            <use
                              xlink:href="#b1A6lYlsPS"
                              opacity="1"
                              fill="#000000"
                              fill-opacity="1"
                            ></use>
                            <g>
                              <use
                                xlink:href="#b1A6lYlsPS"
                                opacity="1"
                                fill-opacity="0"
                                stroke="#000000"
                                stroke-width="1"
                                stroke-opacity="0"
                              ></use>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div class="dol_name">
                      <template>{{ outlet.name }}</template>
                    </div>

                    <div
                      class="tl_img"
                      style="margin: 10px 0"
                      v-if="outlet.address_image"
                      v-lazyloadImage
                    >
                      <img
                        alt=""
                        class="placeholded-image"
                        style="
                          margin: 10px 0;
                          width: 100%;
                          object-fit: cover;
                          height: 200px;
                        "
                        :data-url="outlet.address_image"
                        width="100%"
                      />
                    </div>

                    <div
                      class="dol_dop"
                      style="visibility: visible; opacity: 1; height: auto"
                      v-if="outlet.address"
                    >
                      <div class="dol_dop_text">{{ outlet.address }}</div>
                    </div>
                  </div>
                </div>
              </label>
            </transition-group>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {
    SET_GUARD_MODE,
    SET_GUARD_OUTLET_ID,
    SET_GUARD_PASS,
    SET_GUARD_TYPE_ID
  } from '@/store/mutations.type'

  import {mapGetters} from 'vuex'
  import {
    GUARD_BACK,
    GUARD_NEXT,
    GUARD_SORT_OUTLETS
  } from '@/store/actions.type'

  import LazyLoadDirective from '../../../directives/LazyLoadDirective'

  export default {
    name: 'OrderTypeAndOutlet',

    data() {
      return {
        types: [],

        type_id: null,
        outlet_id: null,
        identifier: null,

        GUARD_SORT_OUTLETS
      }
    },

    directives: {
      lazyloadImage: LazyLoadDirective
    },

    methods: {
      async next() {
        for (let i in this.outlets) {
          if (this.outlets[i].identifier === this.identifier) {
            this.outlet_id = this.outlets[i].id
            break
          }
        }
        await this.$store.commit(SET_GUARD_TYPE_ID, this.type_id)
        await this.$store.commit(SET_GUARD_OUTLET_ID, this.outlet_id)
        await this.$store.commit(SET_GUARD_PASS, this.identifier)
        await this.$store.dispatch(GUARD_NEXT)
      },

      async back() {
        await this.$store.dispatch(GUARD_BACK)
      },

      async sortByGeo() {
        await this.$store.dispatch(GUARD_SORT_OUTLETS)
      },

      updateTypes() {
        let types = []
        for (let i in this.guardTypes) {
          if (this.hasOutlets(this.guardTypes[i].id)) {
            types.push(this.guardTypes[i])
          }
        }

        this.types = types

        if (this.types.length === 1) {
          this.type_id = this.types[0].id
        }
      },

      setIdentityForType(type) {
        this.identifier = null
        if (this.outlets.length === 1 || type === 3) {
          this.identifier = this.outlets[0].identifier
          this.outlet_id = this.outlets[0].id
        }
      },

      hasOutlets(typeID) {
        for (let i in this.guardOutlets) {
          if (
            this.guardOutlets[i].type_id === typeID &&
            this.guardOutlets[i].city_id === this.$store.getters.guardCityID
          ) {
            return true
          }
        }
        return false
      }
    },

    computed: {
      canGoBack() {
        return (
          this.$store.getters.guardModeInitial ===
          this.$store.getters.guardModes.GUARD_MODE_CITY
        )
      },

      outlets() {
        let outlets = []
        for (let i in this.guardOutlets) {
          if (
            this.guardOutlets[i].type_id === this.type_id &&
            this.guardOutlets[i].city_id === this.$store.getters.guardCityID
          ) {
            outlets.push(this.guardOutlets[i])
          }
        }
        return outlets
      },

      guardShowChooseOutletsAlways() {
        return this.$store.getters.guardShowChooseOutletsAlways
      },

      ...mapGetters(['guardOutlets', 'guardTypes', 'guardCityID'])
    },

    async mounted() {
      this.type_id = this.$store.getters.guardTypeID
      this.identifier = this.$store.getters.guardPass
      this.outlet_id = this.$store.getters.guardOutletID

      this.updateTypes()
      if (this.type_id) {
        this.setIdentityForType(this.type_id)
      }
      if (
        !this.$store.getters.guardShowChooseOutletsAlways &&
        (this.identifier ||
          (this.type_id === 3 && this.$store.getters.guardAddressEnabled))
      ) {
        return await this.next()
      }
    },

    updated() {
      this.$emit('update:identifierData', this.identifier)
      this.$emit('update:typeIdData', this.type)
    },

    watch: {
      guardCityID() {
        this.updateTypes()
      },

      type_id(type) {
        this.setIdentityForType(type)
        this.$emit('update:typeIdData', type)
      },

      identifier(identifier) {
        this.$emit('update:identifierData', identifier)
      }
    }
  }
</script>

<style scoped>
  .sort-geo-button-div {
    height: 24px;
    position: relative;
    top: -10px;
  }

  .sort-geo-button-div .svg_anim {
    width: 25px;
  }

  .sort-geo-button-div svg {
    cursor: pointer;
  }

  .sort-geo-button-div svg:active g {
    filter: blur(1px);
  }

  .flip-list-enter {
    transition: transform 0.75s;
  }

  .substrate {
    border-radius: 10px;
    padding: 15px 10px;
    background-color: #eaf5fe3b;
  }

  .super-slide-enter-active,
  .super-slide-leave-active {
    transition: all 0.5s ease;
  }

  .super-slide-enter,
  .super-slide-leave-to {
    transform: translateY(300%);
  }

  .super-slide-down-enter-active,
  .super-slide-down-leave-active {
    transition: all 0.5s ease;
    background: rgba(255, 255, 255, 1) !important;
  }

  .super-slide-down-enter,
  .super-slide-down-leave-to {
    transition: all 0.5s ease;
    transform: translateY(-300%);
    background: rgba(255, 255, 255, 0) !important;
  }

  .left-enter-active {
    transition: all 0.4s ease;
  }

  .left-leave-active {
    transition: all 0.4s ease;
  }

  .left-enter,
  .left-leave-to {
    transform: translateX(-100vw);
    opacity: 0;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.7s;
  }

  .list-enter,
  .list-leave-to {
    opacity: 0.8;
    transform: translateY(-100%);
  }

  .list-leave-to {
    transition: all 0s;
  }

  .change_address .dol_dop_text:hover {
    cursor: pointer;
    color: #5c5c5c;
  }

  .change_address .dol_dop_text:hover img {
    filter: brightness(0.6);
  }
</style>
